import React, { useState } from 'react'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import MoreButton from './MoreButton'
import { LatestNutritionArticles_start_diets } from '../types/LatestNutritionArticles'

type DietCardProps = {
  index: number
  className?: string
} & LatestNutritionArticles_start_diets
function DietCard({ name, image, slug, index, className }: DietCardProps) {
  const commonGradientClasses =
    'absolute inset-0 lg:rounded-8 transition bg-gradient-to-b from-transparent'
  return (
    <div
      className={cn(
        'relative text-left group',
        'col-span-3 first:col-span-6 lg:first:col-span-2 lg:col-span-2',
        index === 0 ? 'text-20' : 'text-14',
        'md:text-24 lg:text-28',
        className
      )}
    >
      <div className={cn(commonGradientClasses, 'to-transparent-30')} />
      <div
        className={cn(
          commonGradientClasses,
          'to-transparent-10 opacity-0 group-hover:opacity-100'
        )}
      />
      <Link to={`/nutrition-explained/category/${slug}`} className="fill-link">
        {image && (
          <img src={image.url} alt="" className="lg:rounded-8 w-full" />
        )}
        <span
          className={cn(
            'font-bold text-white',
            'absolute bottom-0 left-0 ',
            'ml-16 mb-12 lg:ml-30 lg:mb-20',
            'transition transform group-hover:-translate-y-1'
          )}
        >
          {name}
        </span>
      </Link>
    </div>
  )
}

type Props = {
  diets: LatestNutritionArticles_start_diets[]
}

function NutritionStartDiets({ diets }: Props) {
  const [expanded, setExpanded] = useState(false)

  return (
    <>
      <div
        className={cn(
          'grid grid-cols-6 gap-1 lg:gap-6',
          'mb-24 lg:mb-48 -mx-20 lg:mx-0'
        )}
      >
        {diets.map((diet, index) => (
          <DietCard
            key={diet.id}
            index={index}
            {...diet}
            className={!expanded && index > 2 ? 'hidden' : undefined}
          />
        ))}
      </div>
      {!expanded && diets.length > 2 && (
        <MoreButton arrow onClick={() => setExpanded(true)}>
          See all diets
        </MoreButton>
      )}
    </>
  )
}

export default NutritionStartDiets
